import {
  ShippingMethodOptionProps,
  ShippingMethodOption as BaseShippingMethodOption,
} from "@made-people/blueprint-checkout";
import { useCentraSelectionResponse } from "@made-people/grease-centra";
import { useTranslate } from "@made-people/grease-translations";
import { useCartState } from "@made-people/grease-cart";
import { Checkmark } from "../../../assets/icons/Checkmark";
import { getCarrierLogo } from "../../../utils/get-carrier-logo";
import { isAllCartItemsOMG } from "../../../utils/is-all-cart-items-in-omg";

export const MMShippingMethodOption = (props: ShippingMethodOptionProps) => {
  const selectionResponse = useCentraSelectionResponse();
  const translate = useTranslate();
  const { cart } = useCartState();
  const country = selectionResponse?.selection?.address?.country || "";
  const allInOMG = isAllCartItemsOMG(cart?.items ?? [], country);

  const logo = getCarrierLogo(country, props.methodKey, props.label, allInOMG);
  const isFreeShipping = props.isFreeShipping;
  const displayPrice = isFreeShipping
    ? translate("Checkout_CartTotals_FreeShipping")
    : props.price;

  return (
    <BaseShippingMethodOption
      logo={logo}
      icons={{ active: <Checkmark className="w-5 h-5" /> }}
      {...props}
      price={displayPrice}
    />
  );
};
